import React, { useEffect, useState } from 'react';
import { Avatar } from '@mui/material';

import UserAvatarInitials from './UserAvatarInitials';
import { useStyle } from './styles';

const UserAvatar = ({
  name,
  src,
  onClick,
  sx = {},
}: {
  name: string;
  src?: string;
  onClick?: () => void;
  sx?: any;
}) => {
  const classes = useStyle();

  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    if (!src) {
      setImageError(true);
      return;
    }

    const img = new Image();
    img.src = src;
    img.onload = () => setImageLoaded(true);
    img.onerror = () => setImageError(true);

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [src]);

  return (
    <>
      <UserAvatarInitials
        name={name}
        sx={{ ...classes.avatar(!imageLoaded), ...sx }}
        onClick={onClick}
      />

      {src && !imageError && (
        <Avatar
          src={src}
          onClick={onClick}
          sx={{ ...classes.avatar(imageLoaded), ...sx }}
          onError={() => setImageError(true)}
        />
      )}
    </>
  );
};

export default UserAvatar;
